<template>
  <div class="space-y-3">
    <div v-if="title" class="text-md font-semibold text-gray-800 mb-2">{{ title }}</div>
    <div v-if="keywords && keywords.length > 0" class="max-h-60 overflow-y-auto pr-2">
      <ul class="space-y-2">
        <li 
          v-for="(keyword, index) in sortedKeywords" 
          :key="index" 
          class="flex justify-between items-center p-2 bg-gray-50 rounded-md hover:bg-gray-100 transition-colors duration-150"
        >
          <span class="text-sm text-gray-700">{{ keyword.term || keyword.name || keyword.keyword }}</span>
          <span 
            class="text-sm font-medium px-2 py-0.5 rounded-full"
            :class="getValueClass(keyword.value || keyword.score || keyword.count)"
          >
            {{ keyword.value || keyword.score || keyword.count }}
            <span v-if="valueSuffix" class="ml-0.5">{{ valueSuffix }}</span>
          </span>
        </li>
      </ul>
    </div>
    <div v-else class="text-sm text-gray-500 italic">
      {{ emptyText }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewKeywordsDisplay',
  props: {
    keywords: { // Expects an array of objects like [{ term: 'clean', value: 10 }, ...]
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: 'Review Keywords'
    },
    valueType: { // 'count', 'seo_value', or other to help with styling/suffix
      type: String,
      default: 'count' // Affects styling and suffix
    },
    emptyText: {
      type: String,
      default: 'No keywords data available'
    },
    sortDescending: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    valueSuffix() {
      if (this.valueType === 'seo_value') return 'SEO Value';
      // Add other suffixes if needed
      return '';
    },
    sortedKeywords() {
      if (!this.keywords) return [];
      return [...this.keywords].sort((a, b) => {
        const valA = a.value || a.score || a.count || 0;
        const valB = b.value || b.score || b.count || 0;
        return this.sortDescending ? valB - valA : valA - valB;
      });
    }
  },
  methods: {
    getValueClass(value) {
      // Basic coloring, can be expanded based on valueType or thresholds
      if (this.valueType === 'seo_value') {
        if (value > 0.7) return 'bg-green-100 text-green-700';
        if (value > 0.4) return 'bg-yellow-100 text-yellow-700';
        return 'bg-red-100 text-red-700';
      }
      if (value > 10) return 'bg-blue-100 text-blue-700';
      if (value > 5) return 'bg-indigo-100 text-indigo-700';
      return 'bg-gray-200 text-gray-800';
    }
  }
};
</script>

<style scoped>
/* Add scrollbar styling for .overflow-y-auto if desired */
</style> 